import {
  HStack,
  IconButton,
  Select,
  Spacer,
  Text,
  VStack,
} from "@chakra-ui/react";
import { X } from "lucide-react";
import { useEffect, useState } from "react";

export function MultiSelectNumber(props: {
  title: string;
  values: Array<number>;
  initialSelectValue?: Array<number>;
  displayValues: Array<string>;
  onChange: (selection: Array<number>) => void;
}) {
  console.log("props", props);
  const [selectionArray, setSelectionArray] = useState<Array<number>>(
    props.initialSelectValue ?? []
  );

  useEffect(() => {
    if (props.displayValues.length > 0) {
      const selectedIndices = props.values
        .map((v, i) => (selectionArray.includes(v) ? i : null))
        .filter((e) => e != null);
      const selectedValues = props.values.filter((v, i) =>
        selectedIndices.includes(i)
      );

      console.log(
        "selectionArray update trigger onChange with selectedValues",
        selectedValues
      );
      props.onChange(selectedValues);
    }
  }, [selectionArray]);

  return (
    <VStack width={"fit-content"} marginLeft={"10px"} marginBottom={"20px"}>
      <Text>{props.title}</Text>
      <HStack>
        <Select
          minW={100}
          placeholder={"-"}
          onChange={(event) => {
            const parsedValue = parseInt(event.target.value, 10);
            // Check if the value is a valid number, if not, fallback to string
            setSelectionArray((old) => {
              return [
                ...old.filter((e) => e !== parsedValue),
                parsedValue,
              ] as Array<number>;
            });
          }}
        >
          {props.values
            .map((e, i) => [e, props.displayValues[i], i])
            .filter((v) => {
              return !selectionArray.includes(v[0] as number);
            })
            .map((v) => {
              console.log("selectList: ", v);
              const val = v[0] as number;
              const dispVal = v[1] as string;
              return (
                <option key={dispVal} value={val as number}>
                  {dispVal}
                </option>
              );
            })}
        </Select>
      </HStack>
      <VStack align={"right"} spacing={0}>
        {props.values
          .map((e, i) => [e, props.displayValues[i], i])
          .filter((v) => selectionArray.includes(v[0] as number))
          .map((v) => {
            console.log("lowerList: ", v);
            const val = v[0];
            const dispVal = v[1];
            return (
              <HStack
                padding="5px"
                margin={"2px"}
                borderRadius={"5px"}
                key={val}
                background={"blue.200"}
                align={"center"}
              >
                <Text fontSize={"18px"}>{dispVal}</Text>
                <Spacer />
                <IconButton
                  aria-label={`close-${val}`}
                  icon={<X />}
                  variant={"ghost"}
                  size={"xs"}
                  onClick={() => {
                    setSelectionArray((oldArray) => {
                      return oldArray.filter((e) => e !== val);
                    });
                  }}
                />
              </HStack>
            );
          })}
      </VStack>
    </VStack>
  );
}

export function MultiSelect(props: {
  title: string;
  values: Array<string>;
  initialSelectValue?: Array<string>;
  displayValues: Array<string>;
  onChange: (selection: Array<string>) => void;
}) {
  //const [initialSelectValue, setIntialSelectValue] = useState(props.initialSelectValue);
  const [selectionArray, setSelectionArray] = useState<Array<string>>(
    props.initialSelectValue ?? []
  );

  useEffect(() => {
    console.log(selectionArray, props.values, props.displayValues);
    if (props.displayValues.length > 0 && props.displayValues.length > 0) {
      const selectedIndices = props.values
        .map((v, i) => (selectionArray.includes(v) ? i : null))
        .filter((e) => e != null);
      const selectedValues = props.values.filter((v, i) =>
        selectedIndices.includes(i)
      )
      .sort((v1, v2) => selectionArray.indexOf(v1) - selectionArray.indexOf(v2));
      props.onChange(selectedValues);
    }
  }, [selectionArray]);

  console.log("===1", props.values.join(","));
  console.log("~~~2", props.displayValues.join(","));
  console.log("---3", selectionArray.join(","));

  return (
    <VStack width={"fit-content"} marginLeft={"10px"} marginBottom={"20px"}>
      <Text>{props.title}</Text>
      <HStack>
        <Select
          minW={100}
          placeholder={"-"}
          onChange={(event) => {
            setSelectionArray((old) => {
              return [
                ...old.filter((e) => e !== event.target.value),
                event.target.value,
              ];
            });
          }}
        >
          {props.values
            .map((e, i) => [e, props.displayValues[i], i])
            .filter((v) => {
              return !selectionArray.includes(v[0] as string);
            })
            .map((v) => {
              console.log("selectList: ", v);
              const val = v[0];
              const dispVal = v[1] as string;
              return (
                <option key={dispVal} value={val}>
                  {dispVal}
                </option>
              );
            })}
        </Select>
      </HStack>
      <VStack align={"right"} spacing={0}>
        {props.values
          .map((e, i) => [e, props.displayValues[i], i])
          .filter((v) => selectionArray.includes(v[0] as string))
          .sort((v1, v2) => selectionArray.indexOf(v1[0] as string) - selectionArray.indexOf(v2[0] as string))
          .map((v) => {
            console.log("lowerList: ", v);
            const val = v[0];
            const dispVal = v[1];
            return (
              <HStack
                padding="5px"
                margin={"2px"}
                borderRadius={"5px"}
                key={val}
                background={"blue.200"}
                align={"center"}
              >
                <Text fontSize={"18px"}>{dispVal}</Text>
                <Spacer />
                <IconButton
                  aria-label={`close-${val}`}
                  icon={<X />}
                  variant={"ghost"}
                  size={"xs"}
                  onClick={() => {
                    setSelectionArray((oldArray) => {
                      return oldArray.filter((e) => e !== val);
                    });
                  }}
                />
              </HStack>
            );
          })}
      </VStack>
    </VStack>
  );
}
